import React from 'react';
import Loader from 'shared/layouts/SearchAutoSuggestions/Loading';


function Loading() {
  return (
    <>
      <Loader items={1} />
      <Loader />
    </>
  );
}

export default Loading;
